module.exports = __webpack_public_path__ + "static/media/icon-realself.573db1e3.png";